import api from '../api/client'

const fichaLeiloeiroService = {
  // Buscar configuração
  getConfig: async (organizadorId) => {
    const response = await api.get(`/configuracoes/ficha-leiloeiro/${organizadorId}`)
    return response.data
  },

  // Salvar configuração
  saveConfig: async (organizadorId, config) => {
    const response = await api.put(`/configuracoes/ficha-leiloeiro/${organizadorId}`, config)
    return response.data
  }
}

export default fichaLeiloeiroService
